import React from "react";
import { useState,useEffect } from "react";
import SalespersonSidebar from "./SalespersonSidebar";
import Editor from 'react-simple-wysiwyg';
import { Helmet } from "react-helmet";
import './classes/AddNews.css';
import { useParams } from 'react-router-dom';
import { Link, useNavigate,useLocation  } from 'react-router-dom';
import { configData } from "../config";
import Loading from './Loading';

const AddNewConferencepage = () => {

    const initialFormData = {
        title:'',
        field_apply_form_desc:'',
        summary: '',
        body: '',
        field_bullet_points_editor:'',
        field_location:'',
        field_meta_title:'',
        field_meta_keywords:'',
        field_meta_description:'',
        field_sales_switch:'',
        field_early_bird_date:'',
        field_limitedseats:'',
        field_general_old_rate:'',
        field_student_old_rate:'',
        field_team_old_rate:'',
        field_prices_increase:'',
        field_speaker_title:'',
        field_speaker_description:'',
        field_new_general_sku:'',
        field_new_student_sku:'',
        field_new_team_sku:'',
        field_image:'',
        field_registration_deadline_day:'',
        field_registration_deadline_month:'',
        field_registration_deadline_year: '',
        field_url_restriction:[],
        field_course_logo:'',
        field_conference_date:'',
        placements: [{ placement_page: '', placement_sort_order: '1' }],
    };

    const [formData,setFormData] =useState(initialFormData);
    const [isLoading, setIsLoading] = useState(true);
    const [errors, setErrors] = useState({});
    const [showSummary, setShowSummary] = useState(false);
    const [editorMode, setEditorMode] = useState({
        body: true,
        bulletPoints: true,
    });
    const [PreviewFields, setPreviewFields] = useState(false);
    const [previewData, setPreviewData] = useState(null);
    const[userLoggedInRoles,setUserLoggedInRoles] = useState([]);

    const [imageUploadError, setImageUploadError] = useState('');
    const [tempImage, setTempImage] = useState(null);
    const [selectedImage, setSelectedImage] = useState(null); 
    const [logoUploadError, setLogoUploadError] = useState('');
    const [tempLogo, setTempLogo] = useState(null);
    const [selectedLogo, setSelectedLogo] = useState(null);
    const [courses, setCourses] = useState([]);
    const [pages, setPages] = useState([]);
    const [disabled, setDisabled] = useState(false);
    const domainName = window.location.hostname;
    const loggedin_drupal_uid = localStorage.getItem('drupal_uid');
    const drupal_domain_url = configData.DRUPAL_DOMAIN_URL;
    const location  = useLocation();
    const drupal_uid = localStorage.getItem('drupal_uid');  
    var loggedin_domain = drupal_domain_url;
    if(localStorage.getItem('loggedin_domain')) {
        loggedin_domain = localStorage.getItem('loggedin_domain');
    } 
    var {uid} = useParams();
    var {username} = useParams();
    if(location.state) {
        uid = location.state;
    }

    const {tab} = useParams();
    const loggedin_uid = localStorage.getItem('uid');
    const navigate = useNavigate();
    const app_url = configData.APP_URL;
    const domain_url = configData.DOMAIN_URL;

    useEffect(() => {
        Promise.all([
            getplacementlist(),
            getcourselist(),
            getuserloggedinroles(),
        ]).then(() => {
            setIsLoading(false);
        })
    }, []);
    
    const months = [
        { value: "01", label: "Jan" },
        { value: "02", label: "Feb" },
        { value: "03", label: "Mar" },
        { value: "04", label: "Apr" },
        { value: "05", label: "May" },
        { value: "06", label: "Jun" },
        { value: "07", label: "Jul" },
        { value: "08", label: "Aug" },
        { value: "09", label: "Sep" },
        { value: "10", label: "Oct" },
        { value: "11", label: "Nov" },
        { value: "12", label: "Dec" }
    ];
    const days = Array.from({ length: 31 }, (_, i) => {
        const day = String(i + 1).padStart(2, "0");
        return { value: day, label: day };
    });

    // From 2017 (the first conferences) to a few years ahead of today
    const lastYear = Math.max(2029, new Date().getFullYear() + 5);
    const years = Array.from(
        { length: lastYear - 2017 + 1 },
        (_, i) => {
            const year = String(2017 + i);
            return { value: year, label: year };
        }
    );

    const salesSwitch = [
        { value: "Registration Open", label: "Registration Open" },
        { value: "Be the first to know", label: "Be the first to know" },
        { value: "Free Registration Form", label: "Free Registration Form" },
    ];

    const urlRestriction = [
        {value: configData.RSMWW_DOMAIN, label: "SportsManagementWorldwide.com"},
        {value: configData.RSMWW_AGENCY_DOMAIN, label: "SMWWAgency.com"},
        {value: configData.RSMWW_SCOUT_DOMAIN, label: "SMWWScout.com"}
    ]

    async function getcourselist() {
        try {
            const response = await fetch(
                app_url+'report/getajaxcourselist',
                {
                    method: "GET",
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
                setCourses(responsedata.data.result);
            } 
        } catch (err) {
        
        }
    
    }
    async function getplacementlist() {
        try {
            const response = await fetch(
                app_url+'node/getnodepages',
                {
                    method: "GET",
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
                setPages(responsedata.data.result);
            } 
        } catch (err) {
            
        }
    }

    async function getuserloggedinroles() {
        try {
            setIsLoading(true);
            const response = await fetch(
                app_url+'viewprofile/getuserloggedinrolesid',
                {
                    method: "GET",
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
                setUserLoggedInRoles(responsedata.data.roles);
            } 
        } catch (err) {
                
        }finally {
            setIsLoading(false); // Set loading to false after fetch completes (success or error)
        }
        
    }   

    const getFileIcon = (fileName) => {
        const extension = fileName.split('.').pop().toLowerCase();

        switch (extension) {
            case 'txt':
            return '/basic/web/images/text-plain.png';
            case 'pdf':
            return '/basic/web/images/application-pdf.png';
            case 'docx':
            return '/basic/web/images/x-office-document.png';
            case 'jpg':
            case 'jpeg':
            return '/basic/web/images/image-x-generic.png';
            case 'xls':
            case 'xlsx':
            return '/basic/web/images/x-office-spreadsheet.png';
            case 'csv':
            return '/basic/web/images/text-x-generic.png';
            case 'mp4':
            return '/basic/web/images/video-x-generic.png';
            case 'png':
            return '/basic/web/images/image-x-generic.png';
            default:
            return '/basic/web/images/image-x-generic.png';
        }
    };

    const handleTempImageChange = (e) => {
        const files = Array.from(e.target.files);
        const file = files[0];
        if (!file) return;

        const validTypes = ['image/png', 'image/jpeg', 'image/jpg', 'image/gif'];
        const maxSize = 128 * 1024 * 1024;
        const errors = [];

        if (!validTypes.includes(file.type)) {
            errors.push('Allowed file types: png, gif, jpg, jpeg.');
        }

        if (file.size > maxSize) {
            errors.push('File must be less than 128 MB.');
        }

        if (errors.length > 0) {
            const errorHTML = `The selected file <em>${file.name}</em> cannot be uploaded. Only files with the following extensions are allowed: <em>png, gif, jpg, jpeg</em>`;
            setImageUploadError(errorHTML);
            e.target.value = '';
            setTempImage(null);
            return;
        }

        setImageUploadError(''); // Clear previous error
        const objectUrl = URL.createObjectURL(file);
        setTempImage({
            file,
            preview: objectUrl
        });
    };
    const handleImageUploadClick = () => {
        if (tempImage) {
            setSelectedImage(tempImage);
            setFormData(prev => ({
            ...prev,
            field_image: tempImage.file
            }));
            setImageUploadError(''); // Clear error on successful upload
        }
    };

    // Remove image
    const removeImage = () => {
        setSelectedImage(null);
        setTempImage(null);
        setFormData(prev => ({
            ...prev,
            field_image: "",
        }));
    };

    const imageValue = selectedImage ? selectedImage.file : formData.field_image;
    const fileName =
        imageValue && typeof imageValue === "object" && imageValue.name
        ? imageValue.name
        : typeof imageValue === "string"
        ? imageValue.split("/").pop()
        : "";

    const handleTempLogoChange = (e) => {
        const files = Array.from(e.target.files);
        const file = files[0];
        if (!file) return;

        const validTypes = ['image/png', 'image/jpeg', 'image/jpg', 'image/gif'];
        const maxSize = 128 * 1024 * 1024; // 128 MB
        const errors = [];

        if (!validTypes.includes(file.type)) {
            errors.push('Allowed file types: png, gif, jpg, jpeg.');
        }

        if (file.size > maxSize) {
            errors.push('File must be less than 128 MB.');
        }

        if (errors.length > 0) {
            const errorHTML = `The selected file <em>${file.name}</em> cannot be uploaded. Only files with the following extensions are allowed: <em>png, gif, jpg, jpeg</em>`;
            setLogoUploadError(errorHTML);
            e.target.value = '';
            setTempLogo(null);
            return;
        }

        setLogoUploadError(''); // Clear previous error
        const objectUrl = URL.createObjectURL(file);
        setTempLogo({
            file,
            preview: objectUrl
        });
    };

    const handleLogoUploadClick = () => {
        if (tempLogo) {
            setSelectedLogo(tempLogo);
            setFormData(prev => ({
                ...prev,
                field_course_logo: tempLogo.file // Assuming your backend field is field_course_logo
            }));
            setLogoUploadError(''); // Clear error on successful upload
        }
    };

    const removeLogo = () => {
        setSelectedLogo(null);
        setTempLogo(null);
        setFormData(prev => ({
            ...prev,
            field_course_logo: "",
        }));
    };

    // --- LOGO VALUE & FILENAME RESOLVERS ---

    const logoValue = selectedLogo ? selectedLogo.file : formData.field_course_logo;

    const logoFileName =
        logoValue && typeof logoValue === "object" && logoValue.name
        ? logoValue.name
        : typeof logoValue === "string"
        ? logoValue.split("/").pop()
        : "";


    const formatFileSize = (size) => {
        if (size < 1024) return size + " Bytes";
        else if (size < 1024 * 1024) return (size / 1024).toFixed(2) + " KB";
        else return (size / (1024 * 1024)).toFixed(2) + " MB";
    };

    const getImageSrc = (value) => {
        if (!value) return "";
        if (typeof value === "string") return value; // already a URL from backend
        if (value.preview) return value.preview; // wrapper object { file, preview, name }
        if (value.file && value.file instanceof File) return URL.createObjectURL(value.file); // has file
        if (value instanceof File) return URL.createObjectURL(value); // plain File object
        return "";
    };
    const handleAddPlacement = () => {
        setFormData((prev) => ({
        ...prev,
        placements: [...prev.placements, { placement_page: '', placement_sort_order: '1' }],
        }));
    };

    const handleDeletePlacement = (index) => {
        setFormData((prev) => ({ ...prev, placements: prev.placements.filter((_, i) => i !== index) }));
    };

    const handlePlacementChange = (index, field, value) => {
        setFormData((prev) => {
            const updated = [...prev.placements];
            updated[index] = { ...updated[index], [field]: value };
            return { ...prev, placements: updated };
        });
    };

    const handlePreviewClick = () => {
        const {
            title,
            summary,
            body,
            field_bullet_points_editor,
            field_apply_form_desc,
            field_image,
            field_registration_deadline_month,
            field_registration_deadline_day,
            field_registration_deadline_year,
            field_location,
            field_meta_title,
            field_meta_keywords,
            field_meta_description,
            field_sales_switch,
            field_early_bird_date,
            field_limitedseats,
            field_general_old_rate,
            field_student_old_rate,
            field_team_old_rate,
            field_prices_increase,
            field_speaker_title,
            field_speaker_description,
            field_new_general_sku,
            field_new_student_sku,
            field_new_team_sku,
            field_url_restriction,
            field_course_logo,
            field_conference_date,
        } = formData;

        const newErrors = {};
        if (!title.trim()) {
            newErrors.title = "Title field is required.";
            window.scrollTo(0, 0);
        }

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            setPreviewFields(false);
            return;
        }

        const cleanedSummary = cleanHtmlOutput(summary);
        const cleanedBody = cleanHtmlOutput(body);
        const finalBulletPoints = cleanHtmlOutput(field_bullet_points_editor);

        const hasSummary = cleanedSummary && cleanedSummary.trim() !== '';
        let trimmedHtml = '';

        if (hasSummary) {
            trimmedHtml = cleanedSummary;
        } else if (cleanedBody.includes('<!--break-->')) {
            trimmedHtml = cleanedBody.split('<!--break-->')[0];
        } else {
            const tmp = document.createElement('div');
            tmp.innerHTML = cleanedBody;
            // const plainText = (tmp.textContent || tmp.innerText || "").trim();

            // let snippet = plainText.split('. ')[0];
            // if (snippet.length < 20) {
            //     snippet = plainText.substring(0, 200);
            // }

            // trimmedHtml = snippet ? `<p>${snippet}</p>` : '';
            trimmedHtml = '';
        }

        setPreviewData({
            title,
            summary: hasSummary ? cleanedSummary : '',
            trimmed: trimmedHtml,
            body: cleanedBody,
            field_image,
            field_course_logo,
            field_bullet_points_editor:finalBulletPoints,
            field_apply_form_desc,
            field_registration_deadline_month,
            field_registration_deadline_day,
            field_registration_deadline_year,
            field_location,
            field_meta_title,
            field_meta_keywords,
            field_meta_description,
            field_sales_switch,
            field_early_bird_date,
            field_limitedseats,
            field_general_old_rate,
            field_student_old_rate,
            field_team_old_rate,
            field_prices_increase,
            field_speaker_title,
            field_speaker_description,
            field_new_general_sku,
            field_new_student_sku,
            field_new_team_sku,
            field_conference_date,
            field_url_restriction: Array.isArray(field_url_restriction) &&
            field_url_restriction.length === 0
            ? ''
            : field_url_restriction,
        });

        setErrors({});
        setPreviewFields(true);
        window.scrollTo(0, 0);
    };

    const cleanHtmlOutput = (html) => {
        if (!html || typeof html !== 'string') return '';

        let cleaned = html;

        cleaned = cleaned.replace(/<\s*(p|div|h[1-6])[^>]*>\s*(<br\s*\/?>|\&nbsp;|\s)*\s*<\/\1\s*>/gi, '');

        cleaned = cleaned.replace(/<br\s*\/?>/gi, '');

        const textOnly = cleaned.replace(/&nbsp;|\s|<[^>]*>/g, '').trim();

        return textOnly.length === 0 ? '' : cleaned.trim();
    };

     const toggleEditor = (field) => {
        setEditorMode(prev => ({
            ...prev,
            [field]: !prev[field]
        }));
    };

    const onEditorChange = (field, value) => {
        setFormData(prev => ({
            ...prev,
            [field]: value,
        }));
    };

    const handleChange = (e) => {
        const { name, type, value, checked } = e.target;

        setFormData(prev => {
        if (type === "checkbox" && Array.isArray(prev[name])) {
            return {
            ...prev,
            [name]: checked
                ? [...prev[name], value]
                : prev[name].filter(v => v !== value),
            };
        }

        return {
            ...prev,
            [name]: type === "checkbox" ? checked : value,
        };
        });
    };
    
    const validateForm = () => {
        const newErrors = {};
        if (!formData.title.trim()) {
        newErrors.title = "Title field is required.";
        window.scrollTo(0, 0);
        }
        return newErrors;
    };

    const inputStyle = {
        title: {
        border: errors.title ? '2px solid red' : '1px solid #777'
        }
    };


    const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validateForm();
        setErrors(validationErrors);
        setPreviewFields(false);
        setPreviewFields(false);
        setImageUploadError("");
        setLogoUploadError("");
        window.scrollTo(0, 0);

        if (Object.keys(validationErrors).length > 0) return;

        // 1. Show "Saving..." on the submit button and disable interactive elements
        setFormData(prevState => ({
            ...prevState,
            button_name: "Saving..."
        }));
        setDisabled(true);

        const cleanedSummary = cleanHtmlOutput(formData.summary);
        const cleanedBody = cleanHtmlOutput(formData.body); // Fallback to state body
        const finalBulletPoints = cleanHtmlOutput(formData.field_bullet_points_editor);

        // 2. Instantiate FormData
        const postData = new FormData();

        // 3. Append media files to postData (Check if state exists and holds a valid browser File)
        if (selectedImage && selectedImage.file) {
            postData.append('field_image', selectedImage.file);
        }
        if (selectedLogo && selectedLogo.file) {
            postData.append('field_course_logo', selectedLogo.file);
        }

        // 4. Normalize array-based fields so they don't break on the backend 
        const updatedFormData = {
            ...formData,
            summary: cleanedSummary,
            body_summary: cleanedSummary,
            body: cleanedBody,
            field_bullet_points_editor:finalBulletPoints,
            field_url_restriction: Array.isArray(formData.field_url_restriction) &&
                formData.field_url_restriction.length === 0
                ? ''
                : formData.field_url_restriction,
        
        };

        postData.append('formData', JSON.stringify(updatedFormData));

        try {
            // 5. Send POST request
            const response = await fetch(app_url + 'pages/addconferencepage', {
                method: 'POST',
                body: postData,
            });

            const data = await response.json();

            if (data.data && data.data.msg === "Success") {  
                // The new conference page, at the address it was given
                window.location.href = '/' + data.data.url_slug;
            } else {
                // Show why it was not saved, and let the form be sent again
                setErrors({ save: (data.data && data.data.text) || data.message || "The conference page could not be saved." });
                setDisabled(false);
                setFormData(prevState => ({
                    ...prevState,
                    button_name: "Save"
                }));
            }
        } catch (error) {
            console.error("Error during form submission: ", error);
            setErrors({ save: "The conference page could not be saved." });
            setDisabled(false);
            setFormData(prevState => ({
                ...prevState,
                button_name: "Save"
            }));
        }
    };

    return (
        <>
            {isLoading ? (
                <Loading />
            ) : (
                <div id="main">
                    <Helmet>
                        <title>
                            Create Conferences | SMWW 
                        </title>
                    </Helmet>
                    <div className="left"></div>
                    <div className="center left-center">
                        <h1>Create Conferences</h1>
                        <div className="agency-news-create-preview">
                            {PreviewFields && (
                            <>
                                <div
                                    className="messages status"
                                    style={{
                                        background: `#f0f8eb url("/basic/web/images/message-ok.png") no-repeat`,
                                        backgroundPosition: '10px 10px',
                                    }}
                                >
                                    The trimmed version of your post shows what your post looks like when promoted
                                    to the main page or when exported for syndication.
                                    <span>
                                        You can insert the delimiter &lt;!--break--&gt; (without the quotes) to
                                        fine-tune where your post gets split.
                                    </span>
                                </div>

                                <div className="preview-container">
                                    {/* Trimmed version */}
                                    <div className="preview-trimmed">
                                        <h4 className="preview-heading">
                                            Preview trimmed version
                                        </h4>

                                        <div className="email-teaser">
                                            <h2 className="email-title">
                                                <span style={{color: "#2C99D2"}}>{previewData?.title}</span>
                                            </h2>

                                            {(previewData.summary?.trim() || previewData.body?.includes('<!--break-->') || previewData.trimmed) && (
                                                <div
                                                    className="preview-body-content"
                                                    dangerouslySetInnerHTML={{ __html: previewData.trimmed }}
                                                />
                                            )}
                                        </div>
                                    </div>

                                    {/* Full version */}
                                    <div className="preview-full">
                                        <h4 className="preview-heading">
                                            Preview full version
                                        </h4>
                                        <div className="email-teaser">
                                            <h2 className="email-title">
                                                {/* <strong>Body:</strong> */}
                                            </h2>
                                            <div
                                                dangerouslySetInnerHTML={{
                                                __html: previewData.body || '',
                                                }}
                                            />
                                            <div className="email-meta">
                                                {previewData.field_apply_form_desc && (
                                                    <p><strong>Form Description:</strong> {previewData.field_apply_form_desc}</p>
                                                )}
                                                {previewData.field_meta_title && (
                                                <p><strong>Meta Title:</strong> {previewData.field_meta_title}</p>)}
                                                {previewData.field_meta_keywords && (
                                                <p><strong>Meta Keywords:</strong> {previewData.field_meta_keywords}</p>)}
                                                {previewData.field_meta_description && (
                                                <p><strong>Meta Description:</strong> {previewData.field_meta_description}</p>)}

                                                {/* Next Start Date Schedule */}
                                                {(previewData.field_registration_deadline_month || previewData.field_registration_deadline_day) && (
                                                    <p>
                                                        <strong>Next Start Date: </strong> 
                                                        {previewData.field_registration_deadline_month || 'None'} - {previewData.field_registration_deadline_day || 'None'}
                                                    </p>
                                                )}
                                                {previewData.field_registration_deadline_year && (
                                                    <p><strong>Year:</strong> {previewData.field_registration_deadline_year}</p>
                                                )}
                                                {previewData.field_location && (
                                                    <p><strong>Location:</strong> {previewData.field_location}</p>
                                                )}
                                                {previewData.field_sales_switch && (
                                                    <p><strong>Sales switch:</strong> {previewData.field_sales_switch}</p> 
                                                )} 
                                                {previewData.field_early_bird_date && (
                                                    <p><strong>Early Bird Date:</strong> {previewData.field_early_bird_date}</p> 
                                                )}
                                                {previewData.field_limitedseats && (
                                                    <p><strong>Limited Seats:</strong> {previewData.field_limitedseats}</p> 
                                                )}
                                                {previewData.field_general_old_rate && (
                                                    <p><strong>General old rate:</strong> {previewData.field_general_old_rate}</p> 
                                                )}
                                                {previewData.field_student_old_rate && (
                                                    <p><strong>Student old rate:</strong> {previewData.field_student_old_rate}</p> 
                                                )}
                                                {previewData.field_team_old_rate && (
                                                    <p><strong>Team old rate:</strong> {previewData.field_team_old_rate}</p> 
                                                )}
                                                {previewData.field_prices_increase && (
                                                    <p><strong>Prices Increase/Last Day Registration:</strong> {previewData.field_prices_increase}</p> 
                                                )}
                                                {previewData.field_bullet_points_editor && (
                                                    <p><strong>Bullet Points Editor:</strong>   
                                                    <div  dangerouslySetInnerHTML={{ __html: previewData.field_bullet_points_editor || '', }}></div></p> 
                                                )}
                                                {previewData.field_speaker_title && (
                                                    <p><strong>Speakers Photos Main Title:</strong> {previewData.field_speaker_title}</p> 
                                                )}
                                                {previewData.field_speaker_description && (
                                                    <p><strong>Speakers Photos Description:</strong> {previewData.field_speaker_description}</p> 
                                                )}
                                                {previewData.field_new_general_sku && (
                                                    <p><strong>New General SKU:</strong> {previewData.field_new_general_sku}</p> 
                                                )}
                                                {previewData.field_new_student_sku && (
                                                    <p><strong>New Student Sku:</strong> {previewData.field_new_student_sku}</p> 
                                                )}
                                                {previewData.field_new_team_sku && (
                                                    <p><strong>New Team Sku:</strong> {previewData.field_new_team_sku}</p> 
                                                )}
                                                {previewData.field_image && (
                                                    <div>
                                                        <strong>Avatar:</strong><br />
                                                        <img 
                                                            src={getImageSrc(previewData.field_image)} 
                                                            alt="Preview" 
                                                            style={{ height: "100px", width: "100px", marginTop: "5px" }} 
                                                        />
                                                    </div>
                                                )}
                                                {previewData.field_course_logo && (
                                                    <div>
                                                        <strong>Conference Logo:</strong><br />
                                                        <img 
                                                            src={getImageSrc(previewData.field_course_logo)} 
                                                            alt="Preview" 
                                                            style={{ height: "100px", width: "100px", marginTop: "5px" }} 
                                                        />
                                                    </div>
                                                )}
                                                {previewData.field_url_restriction && (
                                                    <p>
                                                    <strong>URL Restriction:</strong>{" "}
                                                    {urlRestriction.filter(opt => previewData.field_url_restriction.includes(opt.value)).map(opt => opt.label).join(", ")}
                                                    </p>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                            )}
                        </div>
                        <div className="agency-news-create-container">
                            {Object.values(errors).some(msg => !!msg) && (
                                <div
                                    className="set-message-error error-message-padding"
                                    style={{
                                    background: `#fef5f1 url("/basic/web/images/message-24-error.png") left 10px top 7px no-repeat`
                                    }}
                                >
                                    <ul>
                                    {Object.values(errors)
                                        .filter(msg => !!msg)
                                        .map((msg, index) => (
                                        <li key={index}>{msg}</li>
                                        ))}
                                    </ul>
                                </div>
                            )}
                            <form onSubmit={handleSubmit}>
                                <div>
                                    <div className="form-item">
                                        <label htmlFor="edit-title">
                                            Title  
                                            <span className="form-required" title="This field is required.*">*</span>
                                        </label>
                                        <input
                                            type="text" 
                                            id="edit-title" 
                                            name="title" 
                                            maxLength={255}
                                            onChange={handleChange} 
                                            value={formData.title}
                                            style={inputStyle.title}
                                        />
                                    </div>
                                    <div className="form-item  fieldmeta-description">
                                        <label>Description for Apply Form </label>
                                        <textarea
                                            name="field_apply_form_desc"
                                            value={formData.field_apply_form_desc}
                                            onChange={handleChange}
                                        />
                                        <div className="grippie" style={{
                                            background: `#eee url(/basic/web/images/grippie.png) no-repeat center 2px`,
                                        }}>   
                                        </div>
                                    </div>

                                    
                                    <div>
                                        <div>
                                            {showSummary && (
                                                <div className="form-item">
                                                    <label htmlFor="create_summary">
                                                        Summary <span>(<a className="" href="#" onClick={(e) => { e.preventDefault(); setShowSummary(false); }}>Hide Summary</a>)</span>
                                                    </label>
                                                    <>
                                                        <Editor 
                                                        value={formData.summary} 
                                                        onChange={(e) => {
                                                            const newValue = e?.target?.value || '';
                                                            setFormData((prev) => ({ ...prev, summary: newValue }));
                                                        }}
                                                        />
                                                    </>
                                                    <div className="description">Leave blank to use trimmed value of full text as the summary.</div>
                                                </div>
                                            )}
                                    
                                            <div className="form-item">
                                                <label htmlFor="create_body">
                                                    Body
                                                    {!showSummary && (
                                                        <span>
                                                            (<a href="#" onClick={(e) => { e.preventDefault(); setShowSummary(true); }}>
                                                                Edit Summary
                                                            </a>)
                                                        </span>
                                                    )}
                                                </label>
                                                <>
                                                   {editorMode.body ? (
                                                <Editor
                                                    containerProps={{ style: { resize: 'vertical', height:'300px' } }}  
                                                    value={formData.body} 
                                                    onChange={e => onEditorChange('body', e.target.value)} 
                                                />
                                            ) : (
                                                <>
                                                    <textarea 
                                                        className="new-conference-form-textarea" 
                                                        name="body"
                                                        value={formData.body} 
                                                        onChange={e => onEditorChange('body', e.target.value)} 
                                                        rows={20} 
                                                    />
                                                    <div
                                                        className="grippie" 
                                                        style={{background: `#eee url(/images/grippie.png) no-repeat center 2px`,}}
                                                    >
                                                    </div>
                                                </>
                                            )}
                                            <a onClick={() => toggleEditor('body')}>Switch to {editorMode.body ? 'Plain' : 'Rich'} Editor</a>
                                                </>
                                            </div>
                                        </div>
                                
                                        <div>
                                            <label>Image</label>
                                            {imageUploadError && (
                                                <div
                                                        className="set-message-error error-message-padding"
                                                        style={{
                                                        background: `#fef5f1 url("/basic/web/images/message-24-error.png") left 10px top 7px no-repeat`
                                                        }}
                                                    >
                                            <div 
                                                style={{ color: '#8c2e0b',
                                                    backgroundColor: '#fef5f1',
                                                    marginBottom: '10px', 
                                                    width: '80%',
                                                    borderRadius: '5px' 
                                                }}
                                                dangerouslySetInnerHTML={{ __html: imageUploadError }}
                                                >                           
                                            </div>
                                            </div>
                                            )}
                                            {selectedImage ? (
                                                // Case 1: New image selected
                                                <div className="edit-agent-image-container">
                                                <img alt="Uploaded" src={selectedImage.preview} width="90" height="100" />
                                                <div className="image-info">
                                                    <img
                                                    className="file-icon"
                                                    alt="File icon"
                                                    src={getFileIcon(selectedImage.file.name)}
                                                />
                                                    <a
                                                    href={selectedImage.preview}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="image-name-link"
                                                    >
                                                    {selectedImage.file.name}
                                                    </a>
                                                    <span className="image-size">
                                                    ({(selectedImage.file.size / 1024).toFixed(2)} KB)
                                                    </span>
                                                </div>
                                                </div>
                                            ) : formData.field_image ? (
                                                // Case 2: Image already saved (URL string from backend)
                                                <div className="edit-scout-report-image-container">
                                                <img
                                                    alt="Uploaded"
                                                    src={formData.field_image}
                                                    width="90"
                                                    height="100"
                                                />
                                                <div className="image-info">
                                                    <a
                                                    href={formData.field_image}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="image-name-link"
                                                    >
                                                    {fileName}
                                                    </a>
                                                </div>
                                                </div>
                                            ) : (
                                                // Case 3: No image yet → show upload input
                                                <div>
                                                <input
                                                    type="file"
                                                    id="edit-agent-photo-upload"
                                                    name="edit_agent_photo_upload"
                                                    accept="image/*"
                                                    onChange={handleTempImageChange}
                                                />
                                                <input
                                                    type="button"
                                                    value="Upload"
                                                    className="form-submit"
                                                    onClick={handleImageUploadClick}
                                                />
                                                </div>
                                            )}

                                            {(selectedImage || formData.field_image) && (
                                                <input
                                                type="button"
                                                value="Remove"
                                                className="form-submit"
                                                onClick={removeImage}
                                                />
                                            )}

                                            {!formData.field_image && !selectedImage && (
                                                <div className="description">
                                                Files must be less than <b>128 MB</b>.<br />
                                                Allowed file types: <b>png gif jpg jpeg</b>.
                                                </div>
                                            )}
                                            <div style={{clear: "both"}}></div>
                                        </div>
                                        <div className="form-item">
                                            <label htmlFor="edit-field-call-back-month">Month </label>
                                            <div className="call-back-field">
                                                <select 
                                                    className="" 
                                                    id="edit-field-call-back-month" 
                                                    name="field_registration_deadline_month"
                                                    value={formData.field_registration_deadline_month}
                                                    onChange={handleChange}
                                                >
                                                    <option value="">-None-</option>
                                                    {months.map((m) => (
                                                        <option key={m.value} value={m.value}>
                                                            {m.label}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="form-item">
                                            <label htmlFor="edit-field-call-back-day">Day </label>
                                            <div className="call-back-field">
                                                <select 
                                                    className="" 
                                                    id="edit-field-call-back-day" 
                                                    name="field_registration_deadline_day"
                                                    value={formData.field_registration_deadline_day}
                                                    onChange={handleChange}
                                                >
                                                    <option value="">-None-</option>
                                                    {days.map((d) => (
                                                    <option key={d.value} value={d.value}>
                                                        {d.label}
                                                    </option>
                                                    ))}  
                                                </select>
                                            </div>
                                        </div>
                        
                                        <div className="form-item">
                                            <label htmlFor="edit-field-registration-deadline-year">Year </label>
                                            <select 
                                                id="edit-field-registration-deadline-year"
                                                name="field_registration_deadline_year"
                                                value={formData.field_registration_deadline_year}
                                                onChange={handleChange}
                                            >
                                                <option value="">- None -</option>
                                                {years.map((y) => (
                                                    <option key={y.value} value={y.value}>
                                                    {y.label}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="form-item">
                                            <label htmlFor="edit-field-location">Location</label>
                                            <input
                                                className="new-conference-form-input"
                                                type="text"
                                                id="edit-field-location"
                                                name="field_location"
                                                maxLength={60}
                                                value={formData.field_location}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="form-item -field-meta-title">
                                            <label htmlFor="meta_title">Meta Title</label>
                                            <input 
                                                type="text" 
                                                id="meta_title" 
                                                name="field_meta_title" 
                                                value={formData.field_meta_title} 
                                                onChange={handleChange}  
                                                maxLength={255}
                                            /> 
                                        </div>
                                        <div className="form-item field-meta-keywords">
                                            <label htmlFor="meta_keywords">Meta Keywords</label>
                                            <input 
                                                type="text" 
                                                id="meta_keywords" 
                                                name="field_meta_keywords" 
                                                value={formData.field_meta_keywords} 
                                                onChange={handleChange}
                                                maxLength={255}
                                            /> 
                                        </div>
                                        <div className="form-item  fieldmeta-description">
                                            <label>Meta Description</label>
                                            <textarea
                                                name="field_meta_description"
                                                value={formData.field_meta_description}
                                                onChange={handleChange}
                                            />
                                            <div className="grippie" style={{
                                                background: `#eee url(/basic/web/images/grippie.png) no-repeat center 2px`,
                                            }}>   
                                            </div>
                                        </div>

                                        <div className="form-item">
                                            <label htmlFor="edit-field-sales-switch">Sales switch </label>
                                            <select 
                                                id="edit-field-sales-switch"
                                                name="field_sales_switch"
                                                value={formData.field_sales_switch}
                                                onChange={handleChange}
                                            >
                                                <option value="">- None -</option>
                                                {salesSwitch.map((saleSwitch) => (
                                                    <option key={saleSwitch.value} value={saleSwitch.value}>
                                                        {saleSwitch.label}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="form-item">
                                            <label htmlFor="edit-field-early-bird-date">Early Bird Date</label>
                                            <input
                                                className="new-conference-form-input"
                                                type="text"
                                                id="edit-field-early-bird-date"
                                                name="field_early_bird_date"
                                                maxLength={255}
                                                value={formData.field_early_bird_date}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="form-item">
                                            <label htmlFor="edit-field-limitedseats">Limited Seats</label>
                                            <input
                                                className="new-conference-form-input"
                                                type="text"
                                                id="edit-field-limitedseats"
                                                name="field_limitedseats"
                                                maxLength={255}
                                                value={formData.field_limitedseats}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="form-item">
                                            <label htmlFor="edit-field-general-old-rate">General old rate</label>
                                            <input
                                                className="new-conference-form-input"
                                                type="text"
                                                id="edit-field-general-old-rate"
                                                name="field_general_old_rate"
                                                maxLength={255}
                                                value={formData.field_general_old_rate}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="form-item">
                                            <label htmlFor="edit-field-student-old-rate">Student old rate</label>
                                            <input
                                                className="new-conference-form-input"
                                                type="text"
                                                id="edit-field-student-old-rate"
                                                name="field_student_old_rate"
                                                maxLength={255}
                                                value={formData.field_student_old_rate}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="form-item">
                                            <label htmlFor="edit-field-team-old-rate">Team old rate</label>
                                            <input
                                                className="new-conference-form-input"
                                                type="text"
                                                id="edit-field-team-old-rate"
                                                name="field_team_old_rate"
                                                maxLength={255}
                                                value={formData.field_team_old_rate}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="form-item">
                                            <label htmlFor="edit-field-prices-increase">Prices Increase/Last Day Registration</label>
                                            <input
                                                className="new-conference-form-input"
                                                type="text"
                                                id="edit-field-prices-increase"
                                                name="field_prices_increase"
                                                maxLength={255}
                                                value={formData.field_prices_increase}
                                                onChange={handleChange}
                                            />
                                        </div>
                                
                                        <div className="form-item">
                                            <label>Bullet Points Editor</label>
                                            {editorMode.bulletPoints ? (
                                                <Editor value={formData.field_bullet_points_editor} onChange={e => onEditorChange('field_bullet_points_editor', e.target.value)} />
                                            ) : (
                                                    <>
                                                    <textarea  className="new-conference-form-textarea" value={formData.field_bullet_points_editor} onChange={e => onEditorChange('field_bullet_points_editor', e.target.value)} rows={5} />
                                                    <div
                                                        className="grippie" 
                                                        style={{background: `#eee url(/images/grippie.png) no-repeat center 2px`,}}
                                                    >
                                                    </div>
                                                </>
                                            )}
                                            <a onClick={() => toggleEditor('bulletPoints')}>Switch to {editorMode.bulletPoints ? 'Plain' : 'Rich'} Editor</a>
                                        </div>
                                        <div className="form-item">
                                            <label htmlFor="edit-field-speaker-title">Speakers Photos Main Title</label>
                                            <input
                                                className="new-conference-form-input"
                                                type="text"
                                                id="edit-field-speaker-title"
                                                name="field_speaker_title"
                                                maxLength={255}
                                                value={formData.field_speaker_title}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="form-item">
                                            <label htmlFor="edit-field-speaker-description">Speakers Photos Description</label>
                                            <input
                                                className="new-conference-form-input"
                                                type="text"
                                                id="edit-field-speaker-description"
                                                name="field_speaker_description"
                                                maxLength={255}
                                                value={formData.field_speaker_description}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="form-item">
                                            <label htmlFor="edit-field-new-general-sku">New General SKU</label>
                                            <input
                                                className="new-conference-form-input"
                                                type="text"
                                                id="edit-field-new-general-sku"
                                                name="field_new_general_sku"
                                                maxLength={255}
                                                value={formData.field_new_general_sku}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="form-item">
                                            <label htmlFor="edit-field-new-student-sku">New Student Sku</label>
                                            <input
                                                className="new-conference-form-input"
                                                type="text"
                                                id="edit-field-new-student-sku"
                                                name="field_new_student_sku"
                                                maxLength={255}
                                                value={formData.field_new_student_sku}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="form-item">
                                            <label htmlFor="edit-field-new-team-sku">New Team Sku</label>
                                            <input
                                                className="new-conference-form-input"
                                                type="text"
                                                id="edit-field-new-team-sku"
                                                name="field_new_team_sku"
                                                maxLength={255}
                                                value={formData.field_new_team_sku}
                                                onChange={handleChange}
                                            />
                                        </div>
                                
                                        <div>
                                            <label>URL Restriction </label>
                                            <div className="blog-url-restrition-field">
                                            {urlRestriction.map((url) => (
                                                <label style={{fontWeight:"normal"}} key={url.value}>
                                                <input
                                                    type="checkbox"
                                                    name="field_url_restriction"
                                                    value={url.value}
                                                    checked={formData.field_url_restriction.includes(url.value)}
                                                    onChange={handleChange}
                                                />
                                                {url.label}
                                                </label>
                                            ))}
                                            </div>
                                        </div>
                                        <div style={{marginTop:"10px",marginBottom:"10px"}}>
                                            <label>Conference Logo</label>
                                            
                                            {/* Error Message Section */}
                                            {logoUploadError && (
                                                <div
                                                    className="set-message-error error-message-padding"
                                                    style={{
                                                        background: `#fef5f1 url("/basic/web/images/message-24-error.png") left 10px top 7px no-repeat`
                                                    }}
                                                >
                                                    <div 
                                                        style={{ 
                                                            color: '#8c2e0b',
                                                            backgroundColor: '#fef5f1',
                                                            marginBottom: '10px', 
                                                            width: '80%',
                                                            borderRadius: '5px' 
                                                        }}
                                                        dangerouslySetInnerHTML={{ __html: logoUploadError }}
                                                    />
                                                </div>
                                            )}

                                            {/* Preview/Info Section */}
                                            {selectedLogo ? (
                                                // Case 1: New logo chosen but not saved to DB yet
                                                <div className="edit-agent-image-container">
                                                    <img alt="Uploaded Logo Preview" src={selectedLogo.preview} width="90" height="100" />
                                                    <div className="image-info">
                                                        <img
                                                            className="file-icon"
                                                            alt="File icon"
                                                            src={getFileIcon(selectedLogo.file.name)}
                                                        />
                                                        <a
                                                            href={selectedLogo.preview}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className="image-name-link"
                                                        >
                                                            {selectedLogo.file.name}
                                                        </a>
                                                        <span className="image-size">
                                                            ({(selectedLogo.file.size / 1024).toFixed(2)} KB)
                                                        </span>
                                                    </div>
                                                </div>
                                            ) : formData.field_course_logo ? (
                                                // Case 2: Logo already exists in backend/formData
                                                <div className="edit-scout-report-image-container">
                                                    <img
                                                        alt="Course Logo"
                                                        src={formData.field_course_logo}
                                                        width="90"
                                                        height="100"
                                                    />
                                                    <div className="image-info">
                                                        <a
                                                            href={formData.field_course_logo}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className="image-name-link"
                                                        >
                                                            {logoFileName}
                                                        </a>
                                                    </div>
                                                </div>
                                            ) : (
                                                // Case 3: No logo is set or selected -> Show input element
                                                <div>
                                                    <input
                                                        type="file"
                                                        id="edit-course-logo-upload"
                                                        name="edit_course_logo_upload"
                                                        accept="image/*"
                                                        onChange={handleTempLogoChange}
                                                    />
                                                    <input
                                                        type="button"
                                                        value="Upload"
                                                        className="form-submit"
                                                        onClick={handleLogoUploadClick}
                                                    />
                                                </div>
                                            )}

                                            {/* Remove Action Button */}
                                            {(selectedLogo || formData.field_course_logo) && (
                                                <input
                                                    type="button"
                                                    value="Remove"
                                                    className="form-submit"
                                                    onClick={removeLogo}
                                                />
                                            )}

                                            {/* Instructions Panel */}
                                            {!formData.field_course_logo && !selectedLogo && (
                                                <div className="description">
                                                    Files must be less than <b>128 MB</b>.<br />
                                                    Allowed file types: <b>png gif jpg jpeg</b>.
                                                </div>
                                            )}
                                            
                                            <div style={{ clear: "both" }}></div>
                                        </div>
                                        <div className="form-item">
                                            <label htmlFor="edit-field-conference-date">Conference Date</label>
                                            <input
                                                className="new-conference-form-input"
                                                type="text"
                                                id="edit-field-conference-date"
                                                name="field_conference_date"
                                                maxLength={255}
                                                value={formData.field_conference_date}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <fieldset 
                                            className="form-wrapper" 
                                            style={{
                                                border: "1px solid #ccc", 
                                                padding: "15px 20px", 
                                                marginBottom: "15px",
                                                fontFamily: "sans-serif"
                                            }}
                                        >
                                            {/* Fieldset Legend Header */}
                                            <legend style={{ padding: "0 5px", fontWeight: "bold", fontSize: "12px", color: "#333" }}>
                                                
                                            </legend>

                                            <div className="editprofile-fieldset-wrapper">
                                                <label>PLACEMENTS</label>
                                                <table 
                                                    style={{
                                                        width: "100%",
                                                        borderCollapse: "collapse",
                                                        backgroundColor: "white",
                                                        border: "1px solid #ccc",
                                                        fontSize: "11px"
                                                    }} 
                                                    className="placements-table"
                                                >
                                                    <thead>
                                                        <tr style={{ backgroundColor: "#e1e2dc", borderBottom: "1px solid #ccc" }}>
                                                            <th style={{ 
                                                                width: '70%', 
                                                                padding: '6px 10px', 
                                                                textAlign: 'left', 
                                                                fontWeight: 'bold', 
                                                                color: '#333',
                                                                textTransform: 'uppercase',
                                                                borderRight: '1px solid #ccc'
                                                            }}>
                                                                Page
                                                            </th>
                                                            <th style={{ 
                                                                width: '15%', 
                                                                padding: '6px 10px', 
                                                                textAlign: 'left', 
                                                                fontWeight: 'bold', 
                                                                color: '#333',
                                                                textTransform: 'uppercase',
                                                                borderRight: '1px solid #ccc'
                                                            }}>
                                                                Sort Order
                                                            </th>
                                                            <th style={{ 
                                                                width: '15%', 
                                                                padding: '6px 10px', 
                                                                textAlign: 'center', 
                                                                fontWeight: 'bold', 
                                                                color: '#333',
                                                                textTransform: 'uppercase'
                                                            }}>
                                                                Delete
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {formData.placements.map((placement, index) => (
                                                            <tr key={index} style={{ borderBottom: index < formData.placements.length - 1 ? "1px solid #ccc" : "none" }}>
                                                                {/* Page Select Column */}
                                                                <td style={{ padding: '10px', borderRight: '1px solid #ccc' }}>
                                                                    <select
                                                                        className="placement-select"
                                                                        name={`placement_page_${index}`}
                                                                        value={placement.placement_page}
                                                                        onChange={(e) =>
                                                                            handlePlacementChange(index, 'placement_page', e.target.value)
                                                                        }
                                                                        style={{
                                                                            width: "100%",
                                                                            padding: "4px",
                                                                            border: "1px solid #ccc",
                                                                            borderRadius: "2px",
                                                                            fontSize: "12px",
                                                                            boxSizing: "border-box"
                                                                        }}
                                                                    >
                                                                        <option value="">Select a page</option>
                                                                        {pages.length > 0 && (
                                                                            <>
                                                                                {pages.map((item) => (
                                                                                    <option key={item['id']} value={item['id']}>
                                                                                        {item['title']}
                                                                                    </option>
                                                                                ))}
                                                                            </>
                                                                        )}
                                                                    </select>
                                                                </td>

                                                                {/* Sort Order Select Column */}
                                                                <td style={{ padding: '10px', textAlign: 'center', borderRight: '1px solid #ccc' }}>
                                                                    <select
                                                                        name={`placement_sort_order_${index}`}
                                                                        className="adduser-form-select"
                                                                        value={placement.placement_sort_order}
                                                                        onChange={(e) =>
                                                                            handlePlacementChange(index, 'placement_sort_order', e.target.value)
                                                                        }
                                                                        style={{
                                                                            width: "100%",
                                                                            maxWidth: "60px",
                                                                            padding: "4px",
                                                                            border: "1px solid #ccc",
                                                                            borderRadius: "2px",
                                                                            fontSize: "12px"
                                                                        }}
                                                                    >
                                                                        {[...Array(50)].map((_, i) => (
                                                                            <option key={i + 1} value={i + 1}>
                                                                                {i + 1}
                                                                            </option>
                                                                        ))}
                                                                    </select>
                                                                </td>

                                                                {/* Delete Button Column */}
                                                                <td style={{ padding: '10px', textAlign: 'center' }}>
                                                                    <button
                                                                        type="button"
                                                                        className='quick-links-reg-button form-submit'
                                                                        onClick={() => handleDeletePlacement(index)}
                                                                        
                                                                    >
                                                                        Delete
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>

                                                {/* Add Placement Link */}
                                                <div style={{ marginTop: "12px" }}>
                                                    <a
                                                        className="add-placement-link"
                                                        href="#"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            handleAddPlacement();
                                                        }}
                                                        style={{
                                                            color: "#0071B8",
                                                            textDecoration: "none",
                                                            fontWeight: "bold",
                                                            fontSize: "12px"
                                                        }}
                                                        onMouseOver={(e) => e.currentTarget.style.textDecoration = "underline"}
                                                        onMouseOut={(e) => e.currentTarget.style.textDecoration = "none"}
                                                    >
                                                        + Add
                                                    </a>
                                                </div>
                                            </div>
                                        </fieldset>
                                       
                                    </div>
                               
                               
                                    <div className="form-actions form-wrapper" id="create-actions">
                                        <input type="submit" id="create-submit" name="" value={disabled ? "Saving..." : "Save"} disabled={disabled} className="form-submit" />&nbsp;&nbsp;
                                        <input 
                                            type="button" 
                                            id="edit-preview"  
                                            value="Preview" 
                                            className="form-submit" 
                                            onClick={()=> {
                                            handlePreviewClick();
                                            }}
                                        />
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div className="right">
                        <SalespersonSidebar/>
                    </div>
                </div>
            )}
        </>
    );
};
export default AddNewConferencepage;